module.exports = __webpack_public_path__ + "img/DLM_logo.a0e0eb1f.png";